export default {
  registrationFields: []
}